<template>
    <div class="icon-pill" :class="{'hoverable': hoverable}">
        <font-awesome-icon :icon="[iconVariant, icon]"/>
    </div>
</template>

<script>
export default {
    name: 'IconPill',
    props: {
        icon: {
            type: String,
            required: true
        },
        iconVariant: {
            type: String,
            default: 'far'
        },
        hoverable: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
    .icon-pill {
        width: 35px;
        height: 35px;
        background: #fff;
        border-radius: 100%;
        box-shadow: 0 5px 6px #ddd;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hoverable {
        transition: 0.2s;
        &:hover {
            color: #C62929;
        }
    }
</style>
